<template>
  <el-dialog v-if="visible" title="キャンペーンの編集" :visible.sync="visible" :before-close="close">
    <div class="tiktok-campaign-edit">
      <CampaignCreateAccount />
    </div>

    <div class="tiktok-campaign-edit">
      <CampaignCreateTitle />
    </div>

    <div class="tiktok-campaign-edit">
      <CampaignCreatePeriod />
    </div>

    <div class="tiktok-campaign-edit">
      <CampaignCreateTikTokCondition />
    </div>

    <div class="edit-button">
      <el-button @click="onDelete">
        <Icon name="delete-forever" space="right" />
        削除
      </el-button>

      <div>
        <el-button @click="close">キャンセル</el-button>
        <el-button :disabled="is_edit_disabled" type="primary" @click="onSave">保存</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'
import CampaignCreateTikTokCondition from '@/client/components/_organisms/campaign_create_tiktok_condition/Component.vue'
import CampaignCreateAccount from '@/client/components/_organisms/CampaignCreateAccount.vue'
import CampaignCreatePeriod from '@/client/components/_organisms/CampaignCreatePeriod.vue'
import CampaignCreateTitle from '@/client/components/_organisms/CampaignCreateTitle.vue'
import { useCampaignDialogStore } from '@/client/store/useCampaignDialogStore'
export default defineComponent({
  components: {
    Icon,
    CampaignCreateTitle,
    CampaignCreateAccount,
    CampaignCreatePeriod,
    CampaignCreateTikTokCondition
  },
  computed: {
    ...mapState(useCampaignDialogStore, ['api_campaign', 'form', 'mode', 'is_edit_disabled', 'is_form_change'])
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    ...mapActions(useCampaignDialogStore, [
      'setCampaignId',
      'fetchCampaign',
      'fetchCampaignAccounts',
      'updateCampaign',
      'deleteCampaign',
      'setMode',
      'reset'
    ]),
    /**
     * ダイアログキャンペーンを開く
     */
    async open(campaign_id: number) {
      await this.setCampaignId(campaign_id)
      await this.setMode('edit')
      const response = await this.fetchCampaign()

      if (!response.data) {
        this.$notify({
          title: 'キャンペーンの取得に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger'
        })

        this.visible = false
        this.reset()
        return
      }

      await this.fetchCampaignAccounts()

      this.visible = true
    },
    /**
     * ダイアログキャンペーンを閉じる
     */
    close() {
      if (!this.is_form_change) {
        this.visible = false
        this.reset()
        return
      }

      const confirm = window.confirm('編集内容が保存されていません。ダイアログを閉じますか？')

      if (!confirm) {
        return
      }

      this.visible = false
      this.reset()
    },
    /**
     * 保存ボタン
     */
    async onSave() {
      const result = await this.updateCampaign()

      if (result.error && result.error.type === 'MAX_CAMPAIGN_COUNT_OVER') {
        return this.$notify({
          title: 'キャンペーンの変更に失敗しました。',
          message: '同時開催可能件数を超えるため、指定の期間ではキャンペーンを開催できません。',
          customClass: 'danger'
        })
      }

      if (!result.data) {
        return this.$notify({
          title: 'キャンペーンの変更に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger'
        })
      }

      this.$notify({
        title: 'キャンペーンを変更しました。',
        message: '',
        customClass: 'success',
        duration: 5000
      })

      // キャンペーン一覧の更新を親コンポーネントに通知
      this.$emit('campaignUpdated')

      this.visible = false
      this.reset()
    },
    /**
     * 削除ボタン
     */
    async onDelete() {
      const confirm = window.confirm('キャンペーンを削除してよろしいですか？')

      if (!confirm) {
        return
      }

      const result = await this.deleteCampaign()

      if (result.error && result.error.type === 'NO_DATA_EXISTS') {
        return this.$notify({
          title: '対象のキャンペーンはすでに削除されています。',
          message: '',
          customClass: 'danger'
        })
      }

      if (!result.data) {
        return this.$notify({
          title: 'キャンペーンの削除に失敗しました。',
          message: '',
          customClass: 'danger'
        })
      }

      // キャンペーン一覧の更新を親コンポーネントに通知
      this.$emit('campaignUpdated')

      this.$notify({
        title: 'キャンペーンを削除しました。',
        message: '',
        customClass: 'success',
        duration: 5000
      })

      this.visible = false
      this.reset()
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.tiktok-campaign-edit:not(:first-child) {
  margin-top: $spacing-unit * 2;
}

.edit-button {
  display: flex;
  justify-content: space-between;
  margin-top: $spacing-unit * 3;
}

:deep(.el-dialog) {
  .el-dialog__header {
    padding: $spacing-unit * 2;
    color: $text-color-white;
    background-color: $background-dark-color;
  }

  .el-dialog__body {
    padding: $spacing-unit * 2;
  }

  .el-dialog__footer {
    padding: 0 $spacing-unit * 2 $spacing-unit * 2;
  }

  .el-dialog__title,
  .el-dialog__headerbtn .el-dialog__close {
    color: $text-color-white;
  }
}
</style>
